






































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_dimensiones from '@/mixins/axios/indicador_dimensiones'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import indicador_areas from '@/mixins/axios/indicador_areas'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
           
            
           
           /* {
                tag:'tipo_indicador',
                data:'tipo_indicador',
                active:true
            },*/
           {
                tag:'dimension',
                data:'dimension',
                active:true
            },
              {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            
           
        ],





        id:null as any,

      tipo_indicador:'' as any,
     dimension:'' as any,
     
         indicador_areas:[] as any,
         
              indicador_dimdata:[] as any,
      
    }
  },
     mixins: [indicador_dimensiones,indicador_areas],
     validations: {
    
           tipo_indicador: {
      required,
    },
   dimension: {
      required,
    },
     

   
  },
  methods:{
       onChangeA(event){
//console.log(event.target.value)
this.getDataArea(event.target.value);

},
 async getDataArea(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_AREAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_areas=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_DIMENSIONES(row).then(response => {

                    if (response != null) {

 this.indicador_dimdata=this.indicador_dimdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
      
                 this.tipo_indicador=null;
 this.dimension=null;
        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_dim').modal('show')
      },
seteditar(row){

 this.id=row.id;
 this.tipo_indicador=row.tipo_indicador;
this.dimension=row.dimension;
     
                    
          
 $('#ac_modal_indicador_dim').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_DIMENSIONES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_dimdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Dimensiones, refresque la pagina");

                    }
                        $("#ac_modal_indicador_dim").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_DIMENSIONES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la pagina");
  this.indicador_dimdata=this.indicador_dimdata.filter(item => item.id !== dat.id);
 this.indicador_dimdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Dimensiones, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
           tipo_indicador:this.$store.state.indicador_area_sel.id,
           dimension:this.dimension,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio,
tipo_indicador:this.$store.state.indicador_area_sel.id,
};

let data= await this.GET_INDICADOR_DIMENSIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_dimdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
         this.getDataArea();
      //alert('10')
  }
})
export default class Home extends Vue {}

